import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const PolicyRouterRequestCard = ({ routerRequest, classes }) => {
  if (!routerRequest?.dataJson) return null;

  const requestData = routerRequest?.dataJson;
  const vehicleInfo = requestData.vehicleInfo;
  const vin8 = vehicleInfo?.vin?.vin8;
  const fullVin = vehicleInfo?.vin?.fullVin;
  const plate = vehicleInfo?.plate;

  const hasValue = (val) => val != null && val !== undefined && val !== '' && val !== 'null';
  const hasAnyVehicleData = hasValue(vin8) || hasValue(fullVin) || hasValue(plate);
  const hasAnyMemberData = hasValue(requestData.memberInfo?.phoneNumber) || hasValue(requestData.memberInfo?.firstName) || 
                           hasValue(requestData.memberInfo?.lastName) || hasValue(requestData.memberInfo?.address) ||
                           hasValue(requestData.memberInfo?.zip) || hasValue(requestData.memberInfo?.state) || 
                           hasValue(requestData.memberInfo?.policyNumber) || hasValue(requestData.memberInfo?.fullPolicyNumber);

  return (
    <Card variant="outlined" style={{ marginBottom: '20px', width: '100%' }}>
      <CardHeader
        title="Request to Policy Router"
        avatar={<ArrowForwardIcon />}
        className={classes.logSearchDialogHeader}
      />
      <CardContent>
        {requestData && (
          <Box sx={{ mt: 1 }}>
            {requestData.dateOfLoss && (
              <Typography variant="body2" sx={{ ml: 1 }}>
                <strong>Date of loss:</strong> {requestData.dateOfLoss}
              </Typography>
            )}
            {hasAnyMemberData && (
              <>
                <Typography variant="body2" style={{ marginLeft: 8, marginTop: 12, fontWeight: 600 }}>
                  Member Info:
                </Typography>
                {hasValue(requestData.memberInfo?.firstName) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    First Name: {requestData.memberInfo.firstName}
                  </Typography>
                )}
                {hasValue(requestData.memberInfo?.lastName) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    Last Name: {requestData.memberInfo.lastName}
                  </Typography>
                )}
                {hasValue(requestData.memberInfo?.phoneNumber) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    Phone Number: {requestData.memberInfo.phoneNumber}
                  </Typography>
                )}
                {hasValue(requestData.memberInfo?.address) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    Address: {requestData.memberInfo.address}
                  </Typography>
                )}
                {hasValue(requestData.memberInfo?.zip) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    Zip: {requestData.memberInfo.zip}
                  </Typography>
                )}
                {hasValue(requestData.memberInfo?.state) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    State: {requestData.memberInfo.state}
                  </Typography>
                )}
                {hasValue(requestData.memberInfo?.policyNumber) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    Policy Number: {requestData.memberInfo.policyNumber}
                  </Typography>
                )}
                {hasValue(requestData.memberInfo?.fullPolicyNumber) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    Full Policy Number: {requestData.memberInfo.fullPolicyNumber}
                  </Typography>
                )}
              </>
            )}
            {hasAnyVehicleData && (
              <>
                <Typography variant="body2" style={{ marginLeft: 8, marginTop: 12, fontWeight: 600 }}>
                  VIN Info:
                </Typography>
                {hasValue(vin8) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    VIN8: {vin8}
                  </Typography>
                )}
                {hasValue(fullVin) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    Full VIN: {fullVin}
                  </Typography>
                )}
                {hasValue(plate) && (
                  <Typography variant="body2" style={{ marginLeft: 16 }}>
                    Plate: {plate}
                  </Typography>
                )}
              </>
            )}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

PolicyRouterRequestCard.propTypes = {
  routerRequest: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

export default PolicyRouterRequestCard;
